import React, { Fragment } from 'react';
import _ from 'lodash';

import '../../Analyze.scss';
import SubTopic from './SubTopic';

/**
 * Generic component for reference the report topic
 *
 * @param {*} props
 * @returns
 */
const Topic = (props) => {
  const { currentPageState, setCurrentSPageState, data } = props;
  const { page, title, released, subTopics, component } = data;
  const isCurrentPage = currentPageState.page === page;

  /**
   * Get the settings tab menu class if needed.
   */
  const getSettingsTabMenuClass = () => {
    return `settings-tab-menu-${isCurrentPage ? 'title' : 'items'}`;
  };

  /**
   * Get topic style for the cursor
   */
  const getPointerStyle = () => {
    return { cursor: released ? 'pointer' : 'default' };
  };

  /**
   * Call when the topic is clicked by user.
   */
  const onTopicSelected = () => {
    if (released) {
      const subPage = subTopics.length > 0 ? subTopics[0].subPage : '';
      setCurrentSPageState({ page, subPage, component });
    }
  };

  /**
   * Render the subtopics if the topic has a array of.
   */
  const renderSubTopics = () => {
    if (!isCurrentPage) {
      return false;
    }
    const last = subTopics[subTopics.length - 1];
    return _.map(subTopics, (subTopic) => {
      return (
        <SubTopic
          key={subTopic.subPage}
          currentPageState={currentPageState}
          setCurrentSPageState={setCurrentSPageState}
          data={subTopic}
          component={component}
          isLast={last.subPage === subTopic.subPage}
        />
      );
    });
  };

  return (
    <Fragment>
      <div
        onClick={onTopicSelected}
        style={getPointerStyle()}
        className={`settings-tab-menu-item ${getSettingsTabMenuClass()}`}
      >
        {title}
      </div>
      <div className="border-div-sub-menu bb-border">{renderSubTopics()}</div>
    </Fragment>
  );
};

export default Topic;
